import React, { Component } from "react";
import { Row, Col, Input, Checkbox, Button, message } from "antd";
import CryptoJS from "crypto-js";
import { withRouter } from "react-router-dom";
import { API } from "../../API/API";
import { baseConfig } from "../../Config/Config";
import "./Login.css";
import LoginLogo from "../../svg/svgicon/LoginLogo";
class Login extends Component {
  state = {
    username: "",
    password: "",
    saveusername: true,
  };

  componentDidMount = () => {
    let vusername = localStorage.getItem("username");
    if (vusername) {
      this.setState({
        username: vusername,
        saveusername: true,
      });
    }
  };

  onChangeSaveUserName = (value) => {
    this.setState({
      saveusername: value.target.checked,
    });
  };

  onLogin = async () => {
    if (this.state.username && this.state.password) {
      let username = this.state.username;
      let password = this.state.password;

      const param = {
        loginUrl: baseConfig.makurl + "/tender/session/authenticate",
        type: "Customer",
        username: username,
        password: password,
      };
        API.post("/api/tenderauth/login", param, { baseURL: baseConfig.loginurl }).then((response) => {
        // API.post("/app/login", param, { baseURL: baseConfig.loginurl }).then((response) => {  
        if (  
          response.status === 200 &&
          response.data.retData.token &&
          response.data.retData.vendorid < 1
        ) {
              localStorage.setItem("currentEmpID", response.data.retData.userid);

          API.get("/getPermission?empid=" + response.data.retData.userid).then((response) => {
            if (response.status === 200 && response.data.retType === 0) {
              localStorage.setItem("isHold", response.data.retData.isHold);
              localStorage.setItem("isReopen", response.data.retData.isReopen);
              localStorage.setItem("isCancel", response.data.retData.isCancel);
              localStorage.setItem("isClose", response.data.retData.isClose);
              localStorage.setItem("isAdmin", response.data.retData.isAdmin);
              localStorage.setItem("isJWAdmin", response.data.retData.isJWAdmin);
              
              this.props.getPermission(response.data.retData);
            }
          });

          localStorage.setItem("access_token", response.data.retData.token);
          localStorage.setItem("expires_at", response.data.retData.tokenexpiry);
          if (this.state.saveusername) {
            localStorage.setItem("username", username);
          } else {
            localStorage.removeItem("username");
          }
         
          this.props.history.push("/home");
          this.props.successLogin(
            response.data.retData.username,
            baseConfig.CompanyId,
            response.data.retData.positionname,
            response.data.retData.userid,
          );
        } else {
          message.error("Нэвтрэх нэр эсвэл нууц үг буруу байна!");
        }
      });
    } else {
      message.warning("Нэвтрэх нэр болон нууц үг оруулна уу!");
    }
  };

  encrypt = (number) => {
    var key = CryptoJS.enc.Utf8.parse("7061737323313233");
    var iv = CryptoJS.enc.Utf8.parse("7061737323313233");
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(number), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  };

  onChangeUserName = (username) => {
    this.setState({
      username: username,
    });
  };

  onChangePassword = (password) => {
    this.setState({
      password: password,
    });
  };

  render() {
    return (
      <div className="login">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <div className="loginLeftSide">
              <div className="loginLogo">
                <LoginLogo />
              </div>
              <div className="loginHeaderLabel">
                Монголын Алт (МАК) ХХК
              </div>
              <div className="loginLeftLabel">
                Энэхүү систем нь Монголын Алт (МАК) ХХК -н цахим тендер
                шалгаруулалтын систем
              </div>
            </div>
          </Col>
          <Col style={{ backgroundColor: "#fff" }} span={12}>
            <div className="loginFormDiv">
              <div className="Largelabel">Нэвтрэх</div>
              <Row>
                <div className="LoginLabel">Нэвтрэх нэр</div>
                <Col span={24}>
                  <Input
                    size="large"
                    value={this.state.username}
                    onChange={(e) => this.onChangeUserName(e.target.value)}
                    style={{ borderRadius: 8 }}
                  />
                </Col>
              </Row>

              <Row style={{ paddingTop: "16px" }}>
                <div className="LoginLabel">Нууц үг</div>
                <Col span={24}>
                  <Input.Password
                    size="large"
                    onPressEnter={this.onLogin}
                    onChange={(e) => this.onChangePassword(e.target.value)}
                    style={{ borderRadius: 8 }}
                  />
                </Col>
              </Row>
              <Row style={{ paddingTop: "25px" }} align="middle">
                <Col span={12}>
                  <Checkbox
                    checked={this.state.saveusername}
                    onChange={this.onChangeSaveUserName}
                    className="checkBox"
                  >
                    Нэвтрэх нэр сануулах
                  </Checkbox>
                </Col>
                <Col span={12}>
                  <Row justify="end">
                    <Col>
                      {/* <Button type='text' className='loginText'>Нууц үг сэргээх</Button> */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ paddingTop: "25px" }}>
                <Col span={24}>
                  <Button
                    type="primary"
                    className="loginButton"
                    style={{ borderRadius: 8 }}
                    onClick={this.onLogin}
                  >
                    НЭВТРЭХ
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
export default withRouter(Login);
